import React from 'react';
import classNames from 'classnames';

export type IconName =
  | 'WEXICONS_PIN'
  | 'add'
  | 'add_order'
  | 'angle-down'
  | 'angle-right'
  | 'arrow-square-right'
  | 'ballot'
  | 'bell'
  | 'building-community'
  | 'building'
  | 'calendar-due'
  | 'calendar-minus'
  | 'calendar'
  | 'caret-down'
  | 'check'
  | 'checkbox'
  | 'chevron'
  | 'chevrons-left'
  | 'clip'
  | 'clipboard-list'
  | 'clock'
  | 'close'
  | 'copy'
  | 'cross'
  | 'download'
  | 'duplicate'
  | 'email'
  | 'error-notification'
  | 'eye-crossed'
  | 'eye'
  | 'file-analytics'
  | 'file'
  | 'filter-plus'
  | 'garage-open'
  | 'grid-alt'
  | 'help'
  | 'history'
  | 'interrogation'
  | 'invoicing'
  | 'life-ring'
  | 'list-check'
  | 'lock'
  | 'logout'
  | 'mail'
  | 'megaphone'
  | 'menu-dots-vertical'
  | 'minus-small'
  | 'notice-warning'
  | 'pencil'
  | 'pending'
  | 'phone'
  | 'pin'
  | 'player-pause'
  | 'plus-small'
  | 'plus'
  | 'reload'
  | 'return'
  | 'ruler'
  | 'search'
  | 'settings-sliders-outline'
  | 'settings-sliders'
  | 'success-checkmark'
  | 'support'
  | 'system-action'
  | 'ticket'
  | 'trash'
  | 'truck'
  | 'upload'
  | 'users'
  | 'waste';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
}

export const Icon: React.FC<IconProps> = ({ name, className, ...props }) => {
  return (
    <svg 
      className={classNames('iss-icon', className)} 
      {...props}
      style={{ width: '1em', height: '1em', ...props.style, display: 'inline-block', fill: 'currentColor' }}
    >
      <use href={`/icons/icons.svg#${name}`} />
    </svg>
  );
};
